import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Injection } from "@customTypes/injection";

import { consultationQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);

  if (res.data.length) {
    const newData: Injection[] = [];
    for (const i in res.data) {
      const {
        _id,
        service,
        consumables,
        note,
        consultation_id,
        patient_id,
        created_at,
        updated_at,
      } = res.data[i];

      newData.push({
        id: _id,
        consultationId: consultation_id,
        patientId: patient_id,
        service: { label: service?.name, value: service?._id },
        consumables,
        reason: note,
        createdAt: new Date(created_at),
        updatedAt: new Date(updated_at),
      });
    }

    // console.log(newData);
    return newData;
  }
  return null;
};

interface QueryProps {
  consultationId: string;
  isEnabled?: boolean;
}

export const useGetInjectionsForConsultation = ({
  consultationId, isEnabled = true
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: consultationQKeys.injectionsWithFilters(consultationId),
    queryFn: () => {
      return api.get(`injections/consultation/${consultationId}`);
    },
    select,
    enabled: isEnabled,
    staleTime: 1000 * 60 * 5, // 5 minutes

    onError: (res: any) => {
      console.error("[From Get Injections for Consultations ]", res);
      handleErrors(res, "query");
    },
  });
};
